import toast from 'react-hot-toast';
import { LectureSummaryContentTypeEnum, LectureSummaryPlatformSupportEnum } from './types';
/**
 * 마크다운 콘텐츠를 파싱하여 커리큘럼 섹션으로 변환하는 함수
 */ export const parseMarkdownToCurriculumCustom = (markdownContent)=>{
    const sections = [];
    if (!markdownContent?.trim()) return sections;
    const lines = markdownContent.split(/\r?\n/);
    let currentSection = null;
    let currentLesson = null;
    let lessonMarkdownLines = [];
    let sectionOrder = 0;
    let lessonOrder = 0;
    const sectionRegex = new RegExp('^:::section\\[(.*?)\\]');
    const lessonRegex = new RegExp('^:::lesson\\[(.*?)\\]');
    const metaRegex = new RegExp('^:::meta\\[(.*?)\\]');
    for (const line of lines){
        const sectionMatch = line.match(sectionRegex);
        const lessonMatch = line.match(lessonRegex);
        const metaMatch = line.match(metaRegex);
        if (sectionMatch) {
            // 이전 강의 마무리
            if (currentLesson && currentSection) {
                currentLesson.markdown = lessonMarkdownLines.join('\n').trim();
                currentSection.lessons.push(currentLesson);
            }
            // 이전 섹션 마무리
            if (currentSection) sections.push(currentSection);
            // 새 섹션 시작
            lessonMarkdownLines = [];
            currentLesson = null;
            sectionOrder++;
            lessonOrder = 0;
            currentSection = {
                id: `s_custom_${Date.now()}_${sectionOrder}`,
                title: sectionMatch[1].trim(),
                lessons: [],
                order: sectionOrder
            };
        } else if (lessonMatch && currentSection) {
            // 이전 강의 마무리
            if (currentLesson) {
                currentLesson.markdown = lessonMarkdownLines.join('\n').trim();
                currentSection.lessons.push(currentLesson);
            }
            // 새 강의 시작
            lessonMarkdownLines = [];
            lessonOrder++;
            currentLesson = {
                id: `l_custom_${Date.now()}_${lessonOrder}`,
                title: lessonMatch[1].trim(),
                markdown: '',
                order: lessonOrder,
                contentType: LectureSummaryContentTypeEnum.Markdown,
                platformSupport: LectureSummaryPlatformSupportEnum.IdeAndWeb
            };
        } else if (metaMatch && currentLesson) {
            // 메타데이터 파싱
            try {
                const metaData = JSON.parse(metaMatch[1]);
                if (metaData.contentType && Object.values(LectureSummaryContentTypeEnum).includes(metaData.contentType)) {
                    currentLesson.contentType = metaData.contentType;
                }
                if (metaData.platformSupport && Object.values(LectureSummaryPlatformSupportEnum).includes(metaData.platformSupport)) {
                    currentLesson.platformSupport = metaData.platformSupport;
                }
                if (typeof metaData.duration === 'number') currentLesson.duration = metaData.duration;
                if (typeof metaData.videoUrl === 'string') currentLesson.videoUrl = metaData.videoUrl;
                if (typeof metaData.markdownUrl === 'string') currentLesson.markdownUrl = metaData.markdownUrl;
            } catch (e) {
                console.warn('Failed to parse lesson metadata JSON:', metaMatch[1], e);
                toast.error(`강의 '${currentLesson.title}'의 메타데이터 파싱 중 오류가 발생했습니다.`);
            }
        } else if (currentLesson) {
            lessonMarkdownLines.push(line);
        } else if (currentSection && line.trim() !== '' && !currentLesson) {
        // 섹션 설명 등 (현재는 처리하지 않음)
        }
    }
    // 마지막 강의 마무리
    if (currentLesson && currentSection) {
        currentLesson.markdown = lessonMarkdownLines.join('\n').trim();
        currentSection.lessons.push(currentLesson);
    }
    // 마지막 섹션 마무리
    if (currentSection) sections.push(currentSection);
    return sections;
};
/**
 * 섹션 데이터를 저장용 형식으로 변환하는 함수
 */ export const formatSectionsForSave = (sections)=>{
    try {
        const sectionsToReturn = sections.map((section, sectionIndex)=>{
            const sectionPayload = {
                id: section.id.startsWith('s_custom_') || section.id.startsWith('s_imported_') ? undefined : section.id,
                title: section.title,
                order: String(section.order !== undefined ? section.order : sectionIndex + 1),
                lectures: section.lessons.map((lesson, lessonIndex)=>{
                    const lecturePayload = {
                        id: lesson.id.startsWith('l_custom_') || lesson.id.startsWith('l_imported_') ? undefined : lesson.id,
                        title: lesson.title,
                        order: String(lesson.order !== undefined ? lesson.order : lessonIndex + 1),
                        duration: lesson.duration !== undefined ? String(lesson.duration) : undefined,
                        contentType: lesson.contentType || LectureSummaryContentTypeEnum.Markdown,
                        platformSupport: lesson.platformSupport || LectureSummaryPlatformSupportEnum.IdeAndWeb,
                        videoUrl: lesson.videoUrl || undefined,
                        localMarkdownContent: lesson.markdown,
                        markdownUrl: lesson.markdownUrl || undefined
                    };
                    return lecturePayload;
                })
            };
            return sectionPayload;
        });
        console.log('[CurriculumUtils] Returning sections data WITH localMarkdownContent:', sectionsToReturn);
        return sectionsToReturn;
    } catch (error) {
        console.error('Error formatting sections data:', error);
        toast.error('커리큘럼 데이터 포맷 중 오류가 발생했습니다.');
        return null;
    }
};
